import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getpublicprivacypolicy } from "../services/privacypolicy";

const Policy = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getpublicprivacypolicy()
      .then((res) => {
        if (res?.status === true && res.data?.content) {
          setContent(res.data.content);
        } else {
          setContent("Privacy policy is not available right now.");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="full-page-container privacy-policy-page">
      {/* Header with logo, mirrors the login page branding */}
      <div className="privacy-policy-header">
        <Link to="/login" className="privacy-policy-logo-link">
          <img
            className="privacy-policy-logo"
            src={require("../assets/images/logo/service_amylogo.png")}
            alt="Privacy"
          />
        </Link>
        <Link to="/login" className="privacy-policy-back-link">
          &larr; Back to Login
        </Link>
      </div>

      <div className="privacy-policy-body">
        <div className="privacy-policy-card shadow">
          <h1 className="privacy-policy-title">Privacy Policy</h1>
          {loading ? (
            <p className="text-muted mb-0">Loading...</p>
          ) : (
            <div className="privacy-policy-content">{content}</div>
          )}
        </div>
      </div>

      {/* Footer, consistent with the login page */}
      <div className="footer">
        <div className="row">
          <div className="col-md-6 text-left">
            <span>
              Copyrights © 2026{" "}
              <a className="text-danger" href="https://amyfintech.com" target="_blank" rel="noreferrer">
                AMY Fintech Software
              </a>. All Rights Reserved
            </span>
          </div>
          <div className="col-md-6 text-end">
            <span>
              Powered by{" "}
              <a
                href="https://amytechnologies.in/"
                target="_blank"
                rel="noreferrer"
                className="dark-primary font-weight-bold"
              >
                AMY Technologies
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policy;